export default "__VITE_ASSET__DhwjBaSh__"